import React from 'react';
import styled from 'styled-components';
import { fonts } from '../../../assets/styles/fonts';
import { refFontSize, refFontSizeCalc } from '../../utils/dimensions';
import { animations } from '../../../assets/styles/animations';
import colors from '../../../assets/styles/colors';
import { mq } from '../../../assets/styles/mediaQuery';
import Sign from './Sign';

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
`;

const Header = styled.div<{ isActive: boolean }>`
  line-height: 1.6em;
  transition: ${animations.standardDuration};
  transition-property: color;
  width: 90%;
  color: ${({ isActive }) => (isActive ? colors.red : colors.fadedJade)};

  &:hover {
    color: ${colors.red};
  }
`;

const SectionHeader = styled(Header)`
  padding: 0.5em 0;
  font-family: ${fonts.family.main};
  font-weight: ${fonts.weight.bold};
  font-size: ${refFontSize(40)}vw;

  ${mq.tablet} {
    font-size: ${refFontSizeCalc(40, 1.15)}vw;
  }

  ${mq.phone} {
    font-size: ${refFontSizeCalc(40, 1.25)}vw;
  }
`;

const QuestionHeader = styled(Header)`
  padding: 0.8em 0;
  font-family: ${fonts.family.description};
  font-weight: ${fonts.weight.regular};
  font-size: ${refFontSize(22)}vw;

  ${mq.tablet} {
    font-size: ${refFontSizeCalc(22, 1.15)}vw;
  }

  ${mq.phone} {
    font-size: ${refFontSizeCalc(22, 1.25)}vw;
  }
`;

interface Props {
  id: string;
  header: string;
  expanded: boolean;
  toggleAction: (sectionId: string) => void;
  isQuestion?: boolean;
}

const HeaderWrapper = ({ id, expanded, header, isQuestion, toggleAction }: Props) => {
  return (
    <Wrapper id={id} onClick={() => toggleAction(id)}>
      {isQuestion ? (
        <QuestionHeader isActive={expanded}>{header}</QuestionHeader>
      ) : (
        <SectionHeader isActive={expanded}>{header}</SectionHeader>
      )}
      <Sign isRolledDown={expanded} />
    </Wrapper>
  );
};

export default HeaderWrapper;
